import React, { useState, useEffect } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Box,
  Typography,
  Divider,
  Grid,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "./logo.png";

function Menu() {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const toggleMenuVisibility = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
    if (isMobile) {
      setOpen(false);
    }
  };

  //comment 
  const menuItems = [
    { name: "Etat Civil", path: "/etatcivil" },
    { name: "Cursus universitaire", path: "/etude" },
    { name: "Expériences professionnelles et stages", path: "/experience" },
    { name: "Formations professionnelles", path: "/competence" },
    { name: "Autres compétences pertinentes", path: "/autrecompetence" },
    { name: "Fichiers", path: "/fichier" },
    { name: "Résumé", path: "/resume" },
  ];
  const autreMenuItems = [
    { name: "Historique de candidature", path: "/historique" },
  ];

  const AutreMenu = () => {
    return (
      <>
        <Divider variant="middle" />
        <List>
          {autreMenuItems.map((item, index) => (
            <ListItem
              button
              key={index}
              onClick={() => handleMenuItemClick(item.path)}
              sx={{
                backgroundColor: isActive(item.path) ? 'rgb(70, 103, 151) ' : 'transparent',
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="body1"
                    sx={{ fontSize: isMobile ? "10px" : "12px" }}
                  >
                    {item.name}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </>
    );
  };

  const isActive = (path) => location.pathname === path;

  return (
    <Grid display={"none"}>
      {isMobile && (
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{
            position: "fixed",
            top: "20px",
            left: "20px",
            zIndex: 1200,
          }}
          onClick={toggleDrawer}
        >
          <MenuIcon />
        </IconButton>
      )}

      {/* Drawer (menu) */}
      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer}
        sx={{
          "& .MuiDrawer-paper": {
            width: isMobile ? "250px" : "50%",
            height: "100%",
            paddingTop: "10px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "20px",
            borderBottom: "4px solid blue",
          }}
        >
          {/* Logo en haut du menu */}
          <img
            src={logo}
            alt="Logo"
            style={{ width: "50%", maxWidth: "150px" }}
          />
        </Box>

        <List>
          {menuItems.map((item, index) => (
            <ListItem
              button
              key={index}
              onClick={() => handleMenuItemClick(item.path)}
              sx={{
                backgroundColor: isActive(item.path) ? 'rgb(70, 103, 151) ' : 'transparent',
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="body1"
                    sx={{ fontSize: isMobile ? "10px" : "12px" }}
                  >
                    {item.name}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
        <AutreMenu />
      </Drawer>

      {/* Afficher le menu à gauche si ce n'est pas mobile */}
      {!isMobile && isMenuVisible && (
        <Box
          sx={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "15%",
            height: "100%",
            backgroundColor: "#fff",
            boxShadow: "2px 0px 5px rgba(0,0,0,0.2)",
            zIndex: 1200,
            display: "flex",
            flexDirection: "column",
            paddingTop: "20px",
          }}
        >
          {/* Logo en haut du menu */}
          <img
            src={logo}
            alt="Logo"
            style={{ width: "50%", maxWidth: "150px", margin: "0 auto 20px" }}
          />

          {/* Ligne bleue épaisse */}
          <Box sx={{ borderBottom: '1px solid rgb(70, 103, 151)', width: '100%', marginBottom: '20px' }} />

          {/* Bouton pour masquer le menu */}
          <IconButton
            onClick={toggleMenuVisibility}
            sx={{
              position: "absolute",
              right: "-20px",
              top: "50%",
              backgroundColor: "#fff",
              boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
              zIndex: 1201,
            }}
          >
            <ChevronLeft />
          </IconButton>

          <List>
            {menuItems.map((item, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleMenuItemClick(item.path)}
                sx={{
                  backgroundColor: isActive(item.path) ? 'rgb(70, 103, 151)' : 'transparent',
                }}
              >
                <ListItemText
                  primary={
                    <Typography variant="body1" sx={{ fontSize: "12px" }}>
                      {item.name}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
          <AutreMenu />
        </Box>
      )}

      {/* Bouton pour afficher le menu si masqué */}
      {!isMobile && !isMenuVisible && (
        <IconButton
          onClick={toggleMenuVisibility}
          sx={{
            position: "fixed",
            left: "0",
            top: "50%",
            backgroundColor: "#fff",
            boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
            zIndex: 1200,
          }}
        >
          <ChevronRight />
        </IconButton>
      )}
    </Grid>
  );
}

export default Menu;
